export default __webpack_public_path__ + "static/media/Raider's Gloves of the Bloody Fang.7462b35f.jpg";